import { CATEGORY_SELECTED } from 'src/store/actions';

function categoryReducer(state = {}, action) {
  switch (action.type) {
    case CATEGORY_SELECTED:
      return action.category;
    default:
      return state;
  }
}

export { categoryReducer };
